module.exports = __webpack_public_path__ + "82d54b9d9edcbe47ad49644e357112bd.jpg";